import {
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalCloseButton,
  ModalBody,
  ModalFooter,
  Box,
} from "@chakra-ui/react";

/**
 * Why an appointment was cancelled, for the patient.
 *
 * It used to be titled "Appointment Notes" and printed `appointment.note`: the
 * clinic's own field, which held clinical remarks and system events and was
 * never written for this audience. A note reaches a patient only through a
 * deliberate disclosure. See blhWebServer/src/domain/notes/NOTES_DESIGN.md.
 */
export default function AppointmentNotes({apptNotes, setApptNotes}) {
  return (
    <Modal
      isOpen={Boolean(apptNotes?.cancellationReason)}
      onClose={() => setApptNotes(null)}
      size={"md"}
    >
      <ModalOverlay />
      <ModalContent>
        <ModalHeader>Cancellation reason</ModalHeader>
        <ModalCloseButton />
        <ModalBody fontSize={"sm"}>
          <Box>{apptNotes?.cancellationReason}</Box>
        </ModalBody>
        <ModalFooter></ModalFooter>
      </ModalContent>
    </Modal>
  );
}
